import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useFilters = () => {
  const [filterData, setFilterData] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [searchParams] = useSearchParams();

  const closeDrawer = () => setDrawerOpen(false);
  const openDrawer = () => setDrawerOpen(true);
  useEffect(() => {
    const params = Object.fromEntries(searchParams);

    // Remove non filter params
    delete params.page;
    delete params.search;

    setFilterData(params);
  }, [searchParams]);

  return { filterData, setFilterData, drawerOpen, closeDrawer, openDrawer };
};
